import { Injectable } from '@angular/core';
import { AmorphicService } from '../amorphic/amorphic.service';
import { LoginType } from '../../classes/LoginType';
import { WindowService } from '../../../../common/angular-shared/services/window/window.service';
import { AuthenticationService } from '../authentication/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Assumptions } from '../../../../common/js/static/Assumptions';

@Injectable()
export class BaseLoginService extends AuthenticationService {
  controller;

  constructor(
    protected windowService: WindowService,
    protected route: ActivatedRoute,
    protected router: Router,
    private amorphicService: AmorphicService
  ) {
    super(windowService, route, router);

    this.controller = amorphicService.controller;
  }

  public async goToRegister(): Promise<void> {
    await this.router.navigate(['login'], { fragment: 'Register' });
  }

  public async register(): Promise<boolean> {
    const url = this.windowService.nativeWindow.document.location.href;
    return this.controller.register(url).then((success) => {
      this.controller.publicSave();
      return success;
    });
  }

  public async goToLogin(): Promise<void> {
    await this.router.navigate(['login']);
  }

  public async login(loginType?: LoginType): Promise<void> {
    return this.controller.login(loginType);
  }

  public async resetPassword(url: string): Promise<string> {
    return this.controller.resetPassword(url);
  }

  public async finishResetPassword(): Promise<boolean> {
    return this.controller.finishResetPassword();
  }

  public async accountExists(): Promise<boolean> {
    return this.controller.publicCheckEmailExists();
  }

  public async verifyEmail(): Promise<boolean> {
    return this.controller.verifyEmail();
  }

  public async resetEmail(url: string): Promise<void> {
    return this.controller.resetEmail(url);
  }

  public async logout(): Promise<void> {
    this.router.navigate(['logout']);
  }

  async changeEmail(email: string, password: string): Promise<void> {
    // TODO: HL-16573
  }

  async loginWithNewEmail(email: string, password: string): Promise<void> {
    // TODO: HL-16573
  }

  protected async navigateOnError(): Promise<void> {
    // TODO: HL-16573
  }

  async resendVerificationEmail(): Promise<void> {
    // TODO: HL-16573
  }
}
